import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import AcademicsEditModal from './components/AcademicsEditModal';
import Img from '../../../Img';
import { LinkAnchor } from '../../../Links';
import ProspectSectionRow from '../components/ProspectSectionRow';
import config from '../../../../../config';
import styles from '../collegeProspectTab.scss';

const TESTID_PREFIX = 'profile.college-prospect.academics';

const renderRow = (label, value, testId) => (
    <ProspectSectionRow
        label={label}
        value={value}
        testId={testId}
        testIdPrefix={TESTID_PREFIX}
    />
);

const Academics = () => {
    const profileData = useSelector((state) => state.profile?.data) || {};
    const authUser = useSelector((state) => state.auth?.user);
    const studentInfo = profileData.studentInfo || {};
    const playerId = profileData.id;
    const isOwnProfile = !!authUser && !!profileData.memberId && authUser.id === profileData.memberId;

    const [isEditing, setIsEditing] = useState(false);

    const gradYear = studentInfo.graduationDate
        ? moment(studentInfo.graduationDate).year()
        : '';

    const highSchoolValue = (
        <span data-testid={`${TESTID_PREFIX}.high-school.text`}>
            <div>{studentInfo.highSchoolName || ''}</div>
            <div>{studentInfo.highSchoolLocation || ''}</div>
        </span>
    );

    const transcriptValue = studentInfo.transcriptFileName ? (
        <LinkAnchor
            link={`${config.apiHost}/v1/player/${playerId}/studentinfo/transcript`}
            useAnchor
            testId={`${TESTID_PREFIX}.transcript.link`}
        >
            <Img
                src="/img/v4/icons/icon-document.svg"
                alt="Transcript"
                className={styles.academicsFileIcon}
            />
        </LinkAnchor>
    ) : '';

    const tennisResumeValue = studentInfo.tennisResumeFileName ? (
        <LinkAnchor
            link={`${config.apiHost}/v1/player/${playerId}/studentinfo/tennisresume`}
            useAnchor
            testId={`${TESTID_PREFIX}.tennis-resume.link`}
        >
            <Img
                src="/img/v4/icons/icon-document.svg"
                alt="Tennis Resume"
                className={styles.academicsFileIcon}
            />
        </LinkAnchor>
    ) : '';

    return (
        <div className={styles.academicsSection} data-testid={`${TESTID_PREFIX}.container`}>
            <div className={styles.academicsHeader}>
                <div className={styles.academicsTitleBlock}>
                    <h6
                        className={styles.academicsTitle}
                        data-testid={`${TESTID_PREFIX}.title`}
                    >
                        Academics
                    </h6>
                    <div
                        className={styles.academicsSubtitle}
                        data-testid={`${TESTID_PREFIX}.subtitle`}
                    >
                        Viewable by college coaches.
                    </div>
                </div>
                {isOwnProfile && (
                    <button
                        type="button"
                        className={styles.academicsEditBtn}
                        onClick={() => setIsEditing(true)}
                        data-testid={`${TESTID_PREFIX}.edit-btn`}
                    >
                        <Img
                            src="/img/v4/pen.svg"
                            alt=""
                            className={styles.academicsEditIcon}
                        />
                        <span data-testid={`${TESTID_PREFIX}.edit-btn.text`}>Edit</span>
                    </button>
                )}
            </div>

            <div className={styles.academicsCard}>
                <div className={styles.academicsBody}>
                    {renderRow('High School', highSchoolValue, 'high-school')}
                    {renderRow('Graduating:', gradYear, 'graduating')}
                    {renderRow('High School GPA', studentInfo.highSchoolGpa, 'high-school-gpa')}
                    {renderRow('SAT Score', studentInfo.scores?.sat, 'sat-score')}
                    {renderRow('ACT Score', studentInfo.scores?.act, 'act-score')}
                    {renderRow('TOEFL Score', studentInfo.scores?.toefl, 'toefl-score')}
                    {renderRow('Current Coursework', studentInfo.coursework, 'current-coursework')}
                    {renderRow('Major of Interest', studentInfo.majorOfInterest, 'major-of-interest')}
                    {renderRow('Transcript', transcriptValue, 'transcript')}
                    {renderRow('Tennis Resume', tennisResumeValue, 'tennis-resume')}
                </div>
            </div>

            {isEditing && isOwnProfile && (
                <AcademicsEditModal onClose={() => setIsEditing(false)} />
            )}
        </div>
    );
};

export default Academics;
